module.exports = __webpack_public_path__ + "static/mark_6-fd845880f7a0fbf91a3111ae64048da9.png";